"use client";

import React from 'react';
import { FileText, MessageSquare, ListTodo } from 'lucide-react';

const FeaturesSection = () => {
  const features = [
    {
      title: 'ACCURATE SUMMARIES',
      description: 'We are so confident of the accuracy of our summaries that we have a money-back guarantee policy on it.',
      icon: FileText
    },
    {
      title: 'CHAT ACROSS YOUR MEETINGS',
      description: 'Ask questions and discuss about your meetings with your personal AI Secretary',
      icon: MessageSquare
    },
    {
      title: 'EFFICIENT TASK MANAGEMENT',
      description: 'Convert action items into to-do\'s in the task management tool of your choice.',
      icon: ListTodo
    }
  ];

  return (
    <section 
      className="bg-[#121212] text-white py-16 md:py-24 overflow-hidden relative min-h-[500px] md:min-h-[600px] lg:min-h-[700px]"
      style={{
        backgroundImage: `url('/images/home/hero-dashboard.png')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-bold mb-4 text-gray-100 drop-shadow-[0_2px_2px_rgba(0,0,0,0.5)]">
            Step into a Realm of Effortless Collaboration and AI-Driven Efficiency
          </h2>
          <p className="text-lg md:text-xl font-medium mb-2 bg-gradient-to-r from-blue-200 via-indigo-200 to-blue-200 bg-clip-text text-transparent drop-shadow-[0_1px_1px_rgba(0,0,0,0.8)]">
            Pre meeting prep & post meeting assistance even for your mixed language meetings with MeetMinutes
          </p>
        </div>

        <div className="max-w-5xl mx-auto space-y-4">
          {features.map((feature) => (
            <div key={feature.title} className="flex items-start gap-4 p-3">
              <div className="flex-shrink-0 mt-1">
                <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-blue-700 rounded-full flex items-center justify-center text-white shadow-lg">
                  <feature.icon className="h-4 w-4" />
                </div>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-blue-500 drop-shadow-[0_1px_1px_rgba(0,0,0,0.7)] mb-2">
                  {feature.title}
                </h3>
                <p className="text-gray-200 text-lg drop-shadow-[0_1px_1px_rgba(0,0,0,0.8)]">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
